import { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';
import { IRequestStateModel } from 'store/models/general-models/general-models';
import { DS_COLORS } from 'styles';

type DataStatus = Pick<IRequestStateModel, 'pending' | 'fulfilled' | 'error'>;

interface DataLoaderProps<T> {
  data: T | null;
  status: DataStatus;
  loadingMessage?: ReactNode;
  errorMessage?: ReactNode;
  emptyMessage?: ReactNode;
  children: (data: T) => JSX.Element;
}

export const DataLoader = observer(
  <T,>({
    data,
    status,
    loadingMessage,
    errorMessage,
    emptyMessage,
    children,
  }: DataLoaderProps<T>) => {
    if (status.pending) {
      return (
        <>
          {loadingMessage ?? (
            <p className={'body-14'} style={{ color: DS_COLORS.gray[500] }}>
              Загрузка...
            </p>
          )}
        </>
      );
    }

    if (status.error) {
      return (
        <>
          {errorMessage ?? (
            <p className={'body-14'} style={{ color: DS_COLORS.gray[500] }}>
              Ошибка
            </p>
          )}
        </>
      );
    }

    if (
      data === null ||
      (Array.isArray(data) && !data.length) ||
      (typeof data === 'object' && !Object.keys(data).length)
    ) {
      return (
        <>
          {emptyMessage ?? (
            <p className={'body-14'} style={{ color: DS_COLORS.gray[500] }}>
              Нет данных
            </p>
          )}
        </>
      );
    }

    return children(data);
  }
);
